import { createFileRoute } from '@tanstack/react-router';

import { TravelDays } from '@/module/Travel/Request/TravelDays';

export const Route = createFileRoute('/_auth/travel/_travel/days/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TravelDays />;
}
